import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditAnswerDetails } from "shared/audits"
import TaskLink from "../TaskLink"

const TaskAnsweredAuditItemDetails = ({ audit }) => {
  const { auditedChanges, formSubmissionSlug, task } = audit

  return (
    <div>
      <span className="block mb-6">
        Answered a question on <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
      </span>
      {
        Object.keys(auditedChanges).map((prompt) => (
          <AuditAnswerDetails key={prompt} prompt={prompt} audit={audit} />
        ))
      }
    </div>
  )
}

TaskAnsweredAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskAnsweredAuditItemDetails
